import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["__scopeDialog"],
  _excluded2 = ["forceMount"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { OVERLAY_NAME } from './constants';
import { useDialogContext, usePortalContext } from './context';
import { getDataStateValue } from './utils';
import { DomPrimitive } from '../../internal/components/DomPrimitive';
import { Presence } from '../../internal/components/Presence';
import { jsx as _jsx } from "react/jsx-runtime";
var DialogOverlayImpl = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeDialog = props.__scopeDialog,
    overlayProps = _objectWithoutProperties(props, _excluded);
  var context = useDialogContext(OVERLAY_NAME, __scopeDialog);
  return (
    /*#__PURE__*/
    // В оригинальной реализации используется DialogOverlayImpl оборачивается в компонент RemoveScroll из пакета react-remove-scroll
    // <RemoveScroll as={Slot} allowPinchZoom shards={[context.contentRef]}>
    // но при желании его можно добавить точечно обернув DialogOverlay
    // в версии ui-kit не тянем доп зависимость и заменяем его на использование useDisablePageScroll в компоненте DialogContentModal
    _jsx(DomPrimitive.div, _objectSpread(_objectSpread({
      "data-state": getDataStateValue(context.open)
    }, overlayProps), {}, {
      ref: forwardedRef
      // Мы повторно включаем события указателя, предотвращенные `Dialog.Content`, чтобы разрешить прокрутку наложения.
      ,
      style: _objectSpread({
        pointerEvents: 'auto'
      }, overlayProps.style)
    }))
  );
});
DialogOverlayImpl.displayName = "".concat(OVERLAY_NAME, ".Impl");
export var DialogOverlay = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var portalContext = usePortalContext(OVERLAY_NAME, props.__scopeDialog);
  var _props$forceMount = props.forceMount,
    forceMount = _props$forceMount === void 0 ? portalContext.forceMount : _props$forceMount,
    overlayProps = _objectWithoutProperties(props, _excluded2);
  var context = useDialogContext(OVERLAY_NAME, props.__scopeDialog);
  return context.modal ? /*#__PURE__*/_jsx(Presence, {
    present: forceMount || context.open,
    children: /*#__PURE__*/_jsx(DialogOverlayImpl, _objectSpread(_objectSpread({}, overlayProps), {}, {
      ref: forwardedRef
    }))
  }) : null;
});
DialogOverlay.displayName = OVERLAY_NAME;